export class NeverError extends Error {
  value: unknown;

  constructor(message: string, value: unknown) {
    super(message);
    this.name = "NeverError";
    this.value = value;
  }
}

/** A case that should never be hit */
export const assertNever = (
  value: never,
  msg = "Value should never occur",
): never => {
  throw new NeverError(msg, value);
};
